module.exports = __webpack_public_path__ + "static/img/icon-upload-blue.b19d9c17.svg";